import { transparentize } from 'polished'
import styled, { css } from 'styled-components'

const getFadeOverlaySide = (
  side: 'left' | 'right',
  parentBackground: string
) => {
  const sides = {
    left: css`
      background: linear-gradient(
        ${`to right, ${parentBackground} 0%, ${transparentize(0.9, parentBackground)} 100%`}
      );
      left: 0;
      width: 40px;
    `,
    right: css`
      background: linear-gradient(
        ${`to left, ${parentBackground} 0%, ${transparentize(0.9, parentBackground)} 100%`}
      );
      right: 0;
      width: 40px;
    `
  }

  return sides?.[side]
}

const directionTransformer = {
  left: -1,
  right: 1
}

type MarqueeType = {
  translateValue: number
  transitionTime: number
  direction: 'left' | 'right'
  shouldTransform: boolean
}

type FadeOverlayType = {
  side: 'left' | 'right'
  parentBackground: string
}

export const MarqueeContainer = styled.div`
  overflow: hidden;
  width: 100%;
  position: relative;
  background-color: inherit;
`

export const Marquee = styled.div<MarqueeType>`
  ${({ transitionTime, translateValue, direction, shouldTransform }) => css`
    white-space: nowrap;
    transform: translateX(0);
    display: inline-block;

    ${!!shouldTransform &&
    css`
      &:hover {
        transform: translateX(
          ${directionTransformer[direction] * translateValue}px
        );
        transition: transform ${transitionTime}ms linear;
      }
    `}
  `}
`

export const FadeOverlay = styled.div<FadeOverlayType>`
  position: absolute;
  top: 0;
  bottom: 0;
  pointer-events: none;
  width: 100%;
  height: 100%;
  z-index: 1;

  ${({ side, parentBackground }) => getFadeOverlaySide(side, parentBackground)}
`
